/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2022 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import React from 'react'

import { getFullName, User } from '@builddocs/data-management'
import { Avatar, Card, Tooltip } from '@mui/material'

export function AvatarBlock({ user }: { user: User }) {
  const [avatar] = React.useState<string>('')

  // React.useEffect(() => {
  //   getAvatarSource(user.userId).then(avatar => setAvatar(avatar))
  // }, [])

  return (
    <Tooltip key="fullName" placement="bottom" title={getFullName(user)}>
      <Card>
        <Avatar
          src={avatar}
          sx={{ width: 240, height: 240 }}
          variant="rounded"
        />
      </Card>
    </Tooltip>
  )
}
